'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Element2 = require('./Element');

var _Element3 = _interopRequireDefault(_Element2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Last = (_temp = _class = function (_Element) {
  (0, _inherits3.default)(Last, _Element);

  function Last() {
    (0, _classCallCheck3.default)(this, Last);
    return (0, _possibleConstructorReturn3.default)(this, _Element.apply(this, arguments));
  }

  Last.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        render = _props.render;

    var _getIndexes = this.getIndexes(),
        index = _getIndexes[0];

    var _getTotals = this.getTotals(),
        total = _getTotals[0];

    if (total === undefined) {
      throw new Error('Total is not set for parent fieldset');
    }

    if (index < total - 1) {
      return null;
    }

    if (typeof render === 'function') {
      return this.replaceChildren(render({ index: index, total: total }));
    }

    return this.replaceChildren(children);
  };

  return Last;
}(_Element3.default), _class.propTypes = {
  render: _propTypes2.default.func,
  children: _propTypes2.default.node
}, _temp);
exports.default = Last;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/Last.js
 ** module id = 1277
 ** module chunks = 0
 **/